import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// マイカー通勤申請検索
export const i_0008_privateCarInfoQuery = (userCd) => {
  return http.requestQuickGet(apiUrl.apiUrl_PrivateCarInfo + '?userCd=' + userCd)
}
// マイカー通勤申請更新
export const i_0008_update = (params) => {
  return http.requestPost(apiUrl.apiUrl_PrivateCarInfo + '?userCd=' + params.userCd, [params]);
}

// マイカー通勤申請图片查询
export const i_0008_photoFile_get = (photoPath) => {
  return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0')
}

// マイカー通勤申請图片更新
export const i_0008_saveImage = (formData) => {
  return http.requestPostFormData(apiUrl.apiUrl_filesUpdate, formData)
}



// WEBPACK FOOTER //
// ./src/module/api/i_0008.js